import { render, staticRenderFns } from "./mtc_button.vue?vue&type=template&id=2f1c4da6&scoped=true&lang=html&"
import script from "./mtc_button.vue?vue&type=script&lang=js&"
export * from "./mtc_button.vue?vue&type=script&lang=js&"
import style0 from "./mtc_button.vue?vue&type=style&index=0&id=2f1c4da6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c4da6",
  null
  
)

export default component.exports